
import React, { Fragment } from 'react'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Label } from 'reactstrap';

const Datepicker = ({input: {value, onChange, onBlur}, width, placeholder, meta: {touched, error}, ...rest}) => {
  return (
      <Fragment>
      

        <DatePicker
            {...rest}
            placeholderText={placeholder}
            selected={value ? (Object.prototype.toString.call(value) !== '[object Date]') ? value.toDate() : value : null}
            onChange={onChange}
            onBlur={(e, val) => onBlur(val)}
            popperProps={{
                positionFixed: true // use this to make the popper position: fixed
              }}
            onChangeRaw={(e) => e.preventDefault()}
        />
        {touched && error && <Label basic color='red'>{error}</Label>}
                  
      </Fragment>
 
  )
}

export default Datepicker